<template>
  <div class="home">
    Home Page
    <FileUpload />
    <LocaleSwitcher />
    <br />
    <br />
    <v-btn color="success">{{ $t('common.buttons.new') }}</v-btn>
  </div>
</template>

<script>
import FileUpload from '../components/FileUpload.vue';
import LocaleSwitcher from '../components/LocaleSwitcher.vue';

export default {
  components: { FileUpload, LocaleSwitcher },
  name: 'Home',
};
</script>
